import React from 'react';
import { Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t-[0.5px] border-[#E8E1D8] dark:border-[#3A3A3A] bg-[#FEFDFB] dark:bg-[#1A1A1A] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Юридическая информация */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] dark:text-[#F5F1EC] mb-4">
              Юридическая информация
            </h3>
            <div className="space-y-2 text-sm text-[#1A1A1A]/70 dark:text-[#F5F1EC]/70">
              <p>ИП Воропаев Антон Андреевич</p>
              <p>ИНН: 631929680750</p>
              <p>ОГРНИП: 324632700033170</p>
              <p>Дата регистрации: 28.02.2024</p>
              <p className="mt-3">446361, Самарская область,</p>
              <p>Красноярский район, п. Жареный бугор,</p>
              <p>Зеленый бульвар, д. 13</p>
              <p className="mt-3">
                <a 
                  href="/offer.html" 
                  target="_blank"
                  className="text-[#FF6B35] hover:underline"
                >
                  Публичная оферта для физических лиц
                </a>
              </p>
            </div>
          </div>

          {/* Контакты */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] dark:text-[#F5F1EC] mb-4">
              Контакты
            </h3>
            <div className="space-y-3">
              <a 
                href="tel:88462028880" 
                className="flex items-center gap-2 text-sm text-[#1A1A1A] dark:text-[#F5F1EC] hover:text-[#FF6B35] dark:hover:text-[#FF6B35] transition-colors"
              >
                <Phone size={16} className="text-[#FF6B35]" />
                8 (846) 202-88-80
              </a>
              <a 
                href="mailto:info@riosamara.ru" 
                className="flex items-center gap-2 text-sm text-[#1A1A1A] dark:text-[#F5F1EC] hover:text-[#FF6B35] dark:hover:text-[#FF6B35] transition-colors"
              >
                <Mail size={16} className="text-[#FF6B35]" />
                info@riosamara.ru
              </a>
            </div>
          </div>

          {/* Соцсети и режим работы */}
          <div>
            <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] dark:text-[#F5F1EC] mb-4">
              Мы в соцсетях
            </h3>
            <div className="space-y-3">
              <a 
                href="https://vk.com/rio.samara63" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-[#1A1A1A] dark:text-[#F5F1EC] hover:text-[#FF6B35] dark:hover:text-[#FF6B35] transition-colors"
              >
                <svg className="w-4 h-4 text-[#FF6B35]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14c5.6 0 6.93-1.33 6.93-6.93V8.93C22 3.33 20.67 2 15.07 2zm3.15 12.25h-1.46c-.45 0-.59-.36-1.4-1.17-.71-.71-1.02-.8-1.2-.8-.25 0-.32.07-.32.4v1.07c0 .29-.09.46-1.03.46-1.52 0-3.21-.92-4.39-2.64C7.14 9.03 6.72 7.1 6.72 6.7c0-.18.07-.35.4-.35h1.46c.3 0 .41.14.52.46.61 1.73 1.63 3.25 2.05 3.25.16 0 .23-.07.23-.48V7.95c-.05-.98-.58-1.06-.58-1.41 0-.15.13-.3.33-.3h2.29c.25 0 .34.13.34.43v2.92c0 .25.11.34.18.34.16 0 .29-.09.59-.39 1.02-1.15 1.77-2.92 1.77-2.92.09-.18.23-.35.53-.35h1.46c.36 0 .44.18.36.43-.16.69-.75 1.7-1.52 2.73-.13.18-.18.27 0 .48.13.16.58.57.88.91.55.6 1 1.11 1.11 1.47.12.35-.07.53-.42.53z"/>
                </svg>
                VKontakte
              </a>
              <p className="text-sm text-[#1A1A1A]/70 dark:text-[#F5F1EC]/70 mt-4">
                Режим работы: ежедневно, 9:00 - 21:00
              </p>
            </div>
          </div>
        </div>

        {/* Условия оплаты и возвратов */}
        <div className="mt-12 pt-8 border-t-[0.5px] border-[#E8E1D8] dark:border-[#3A3A3A]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Налогообложение и комиссии */}
            <div>
              <h4 className="font-['Playfair_Display'] text-base font-semibold text-[#1A1A1A] dark:text-[#F5F1EC] mb-3">
                Налогообложение и комиссии
              </h4>
              <div className="space-y-2 text-xs text-[#1A1A1A]/70 dark:text-[#F5F1EC]/70">
                <p>• Мастера РИО работают как самозанятые (НПД)</p>
                <p>• Исполнитель самостоятельно оплачивает налог со своих доходов</p>
                <p>• Комиссия коворкинга: 40% (аренда места + сервис)</p>
                <p>• Мастер получает: 60% от стоимости услуги</p>
              </div>
            </div>

            {/* Процедура возврата и споры */}
            <div>
              <h4 className="font-['Playfair_Display'] text-base font-semibold text-[#1A1A1A] dark:text-[#F5F1EC] mb-3">
                Возврат и урегулирование споров
              </h4>
              <div className="space-y-2 text-xs text-[#1A1A1A]/70 dark:text-[#F5F1EC]/70">
                <p>• Возврат возможен в течение 14 дней</p>
                <p>• Обращайтесь: 8 (846) 202-88-80 или info@riosamara.ru</p>
                <p>• Ответственность за возврат несёт ИП Воропаев А.А.</p>
                <p>• Процесс урегулирования споров — на стороне коворкинга РИО</p>
                <p>• Рассмотрение жалоб: 3-5 рабочих дней</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t-[0.5px] border-[#E8E1D8] dark:border-[#3A3A3A]">
          <p className="text-center text-sm text-[#1A1A1A]/60 dark:text-[#F5F1EC]/60">
            © {new Date().getFullYear()} РИО — Сеть парикмахерских коворкингов. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
